import {
  INJECT_EDIT_CONTEXT,
  INJECT_FRAGMENT_CONTEXT
} from "../helpers/symbols.js";
import { inject, computed } from "#imports";
export function defineBlokkliFragment(_config) {
  const ctx = inject(
    INJECT_FRAGMENT_CONTEXT,
    null
  );
  if (!ctx) {
    return {
      uuid: "",
      index: computed(() => 0),
      isEditing: false,
      parentType: computed(() => void 0),
      fieldListType: computed(() => "default"),
      siblings: computed(() => []),
      rootBlocks: computed(() => []),
      options: computed(() => ({})),
      provider: computed(() => null)
    };
  }
  const editContext = inject(INJECT_EDIT_CONTEXT, null);
  if (editContext?.dom && editContext.useBlockRegistration) {
    editContext.useBlockRegistration(editContext.dom, ctx.uuid);
  }
  return ctx;
}
